import { CreateSlice } from "./useStore";
export type ShippingSlice = {
  selectedAddress: Address | null;
  selectedEkspedisi: string;
  opsiPengambilan: OpsiPengambilan;
  pickUpByCourier: boolean;
  addressForCourier: Address | null;
  customExpeditions: { nama: string }[];
  selectAddress: (address: Address | null) => any;
  selectEkspedisi: (ekspedisi: string) => any;
  setOpsiPengambilan: (opsiPengambilan: OpsiPengambilan) => any;
  setPickUpByCourier: (pickUpByCourier: boolean) => any;
  setAddressForCourier: (addressForCourier: Address | null) => any;
  addCustomExpeditions: (expedition: string) => any;
  setCatatan: (catatan: string) => any;
  setCourierName: (courierName: string) => any;
  catatan: string;
  courierName: string;
};

export const initialState: Omit<
  ShippingSlice,
  | "selectAddress"
  | "selectEkspedisi"
  | "setOpsiPengambilan"
  | "setPickUpByCourier"
  | "setAddressForCourier"
  | "addCustomExpeditions"
  | "setCatatan"
  | "setCourierName"
> = {
  selectedAddress: null,
  selectedEkspedisi: "",
  opsiPengambilan: "dikirim",
  pickUpByCourier: false,
  addressForCourier: null,
  customExpeditions: [],
  catatan: "",
  courierName: "",
};

const createShippingSlice: CreateSlice<ShippingSlice> = (set, get) => ({
  ...initialState,
  selectAddress: (selectedAddress) => set({ selectedAddress }),
  selectEkspedisi: (selectedEkspedisi) => set({ selectedEkspedisi }),
  setOpsiPengambilan: (opsiPengambilan) => set({ opsiPengambilan }),
  setPickUpByCourier: (pickUpByCourier) => set({ pickUpByCourier, addressForCourier: null }),
  setCatatan: (catatan) => set({ catatan }),
  setAddressForCourier: (addressForCourier) => set({ addressForCourier }),
  addCustomExpeditions: (newExpedition) =>
    set({
      customExpeditions: [...get().customExpeditions, { nama: newExpedition }],
    }),
  setCourierName: (courierName) => set({ courierName }),
});

export default createShippingSlice;
